import script from "./BugForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BugForm.vue?vue&type=script&setup=true&lang=js"

import "./BugForm.vue?vue&type=style&index=0&id=76275acb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76275acb"]])

export default __exports__